import { styled } from "theme/default/styled";
import { setFlexDFFDC } from "theme/setter/setFlexValues/setFlexDFFDC";

export const SSupportAdministrationPageList = styled.div`
  gap: 12px;

  ${setFlexDFFDC};
`;
